import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function createKasirMembershipCards() {
  return {
    levels: [],
    filtered: [],
    search: '',
    searchTimer: null,
    uploading: null,
    modal: false,
    editing: false,
    form: { level: 1, name: '', preview: null, file: null },

    init() {
      try {
        const cfg = JSON.parse(this.$el.getAttribute('data-config') || '{}');
        this.levels = Array.isArray(cfg.levels) ? cfg.levels : [];
      } catch (e) {
        this.levels = [];
      }
      this.applyFilter();
    },

    applyFilter() {
      const q = (this.search || '').trim().toLowerCase();
      if (q.length < 2) {
        this.filtered = this.levels;
        return;
      }
      this.filtered = this.levels.filter((lv) => {
        const name = String(lv.name || '').toLowerCase();
        const level = String(lv.level ?? '');
        return name.includes(q) || level.includes(q) || `level ${level}`.includes(q);
      });
    },

    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.applyFilter(), 150);
    },

    openAdd() {
      const empty = this.levels.find((l) => !l.image_url) || this.levels[0];
      this.editing = false;
      this.form = {
        level: empty?.level ?? 1,
        name: empty?.name || '',
        preview: null,
        file: null,
      };
      this.modal = true;
    },

    openEdit(lv) {
      this.editing = true;
      this.form = {
        level: lv.level,
        name: lv.name || '',
        preview: lv.image_url || null,
        file: null,
      };
      this.modal = true;
    },

    onLevelChange() {
      const lv = this.levels.find((l) => Number(l.level) === Number(this.form.level));
      if (lv && !this.editing) {
        this.form.name = lv.name || this.form.name;
        if (!this.form.file) this.form.preview = lv.image_url || null;
      }
    },

    onFile(e) {
      const file = e.target.files?.[0];
      if (!file) return;
      this.form.file = file;
      this.form.preview = URL.createObjectURL(file);
    },

    closeModal() {
      this.modal = false;
      this.form.file = null;
    },

    async save() {
      if (!this.editing && !this.form.file) {
        window.toast?.('Pilih gambar kartu.', 'error');
        return;
      }
      if (this.editing && !this.form.file && !this.form.name) {
        window.toast?.('Ubah nama atau ganti gambar.', 'error');
        return;
      }

      this.uploading = this.form.level;
      try {
        const fd = new FormData();
        fd.append('level', String(Number(this.form.level) || 1));
        if (this.form.name) fd.append('name', this.form.name);
        if (this.form.file) fd.append('image', this.form.file);

        const { data } = await axios.post('/api/v1/kasir/gamification/membership-cards', fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        if (data.data?.levels) {
          this.levels = data.data.levels;
          this.applyFilter();
        }
        this.modal = false;
        window.toast?.(data.message || 'Kartu disimpan.', 'success');
      } catch (err) {
        window.toast?.(err.response?.data?.message || 'Gagal menyimpan kartu.', 'error');
      } finally {
        this.uploading = null;
      }
    },

    async remove(lv) {
      const ok = window.confirmDialog
        ? await window.confirmDialog({
            title: 'Hapus gambar kartu?',
            message: lv.name || ('Tier ' + lv.level),
            confirmText: 'Hapus',
            variant: 'danger',
          })
        : window.confirm('Hapus gambar kartu Tier ' + lv.level + '?');
      if (!ok) return;

      this.uploading = lv.level;
      try {
        const { data } = await axios.delete('/api/v1/kasir/gamification/membership-cards/' + lv.level);
        if (data.data?.levels) {
          this.levels = data.data.levels;
          this.applyFilter();
        }
        window.toast?.(data.message || 'Dihapus.', 'success');
      } catch (err) {
        window.toast?.(err.response?.data?.message || 'Gagal hapus.', 'error');
      } finally {
        this.uploading = null;
      }
    },
  };
}

Alpine.data('kasirMembershipCards', createKasirMembershipCards);
